export const GET_PROFILE_APPLICATIONS = 'get_profile_applications';
export const GET_RECRUITER_APPLICATIONS = 'get_recruiter_applications';
export const VIEW_APPLICATION = 'view_application';
export const APPLICATION_ERROR = 'application_error';
export const GET_ALL_JOB_APPLICATIONS = 'get_all_job_applications';
